/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_WhyInputs */

const en_us2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With the same weekly volume, splitting the body or training all of it gives similar results. Choose what fits your schedule. The exercises and sets are still the app's.`)
};

const pt_br2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com o mesmo volume semanal, dividir o corpo ou treiná-lo inteiro dá resultados parecidos. Escolha pelo que cabe na sua agenda. Os exercícios e as séries continuam por conta do app.`)
};

const es_419_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con el mismo volumen semanal, dividir el cuerpo o entrenarlo completo da resultados parecidos. Elige lo que encaje en tu agenda. Los ejercicios y las series siguen a cargo de la app.`)
};

const pt_pt2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com o mesmo volume semanal, dividir o corpo ou treiná-lo todo dá resultados parecidos. Escolhe o que cabe na tua agenda. Os exercícios e as séries continuam a cargo da app.`)
};

const fr_fr2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À volume hebdomadaire égal, diviser le corps ou le travailler en entier donne des résultats similaires. Choisis ce qui colle à ton emploi du temps. Les exercices et les séries restent gérés par l'app.`)
};

const de_de2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei gleichem Wochenvolumen bringen ein aufgeteilter Körper oder Ganzkörpertraining ähnliche Ergebnisse. Wähl, was in deinen Alltag passt. Übungen und Sätze bestimmt weiterhin die App.`)
};

const it_it2_profile_editors_split_why = /** @type {(inputs: Profile_Editors_Split_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A parità di volume settimanale, dividere il corpo o allenarlo tutto insieme dà risultati simili. Scegli quello che si adatta ai tuoi impegni. Esercizi e serie restano scelti dall'app.`)
};

/**
* | output |
* | --- |
* | "With the same weekly volume, splitting the body or training all of it gives similar results. Choose what fits your schedule. The exercises and sets are still..." |
*
* @param {Profile_Editors_Split_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_why = /** @type {((inputs?: Profile_Editors_Split_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_why(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_why(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_why(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_why(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_why(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_why(inputs)
	return en_us2_profile_editors_split_why(inputs)
});
export { profile_editors_split_why as "profile-editors.split_why" }